(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function spawnRipple(btn, event) {
    if (prefersReducedMotion()) return;
    var rect = btn.getBoundingClientRect();
    var x = event.clientX ? event.clientX - rect.left : rect.width / 2;
    var y = event.clientY ? event.clientY - rect.top : rect.height / 2;
    var reach = Math.max(x, rect.width - x) + Math.max(y, rect.height - y);
    var ripple = document.createElement('span');
    ripple.className = 'pc-card__atc-ripple';
    ripple.style.width = ripple.style.height = reach * 2 + 'px';
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';
    ripple.addEventListener('animationend', function () {
      ripple.remove();
    });
    btn.appendChild(ripple);
  }

  function bumpCart() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('pc-cart-bump');
    void icon.offsetWidth;
    icon.classList.add('pc-cart-bump');
    setTimeout(function () {
      icon.classList.remove('pc-cart-bump');
    }, 700);
  }

  function flyToCart(btn, done) {
    var card = btn.closest('.pc-card');
    var img = card && card.querySelector('.pc-card__img');
    var src = img && (img.currentSrc || img.src);
    var target = document.getElementById('cart-icon-bubble');
    if (prefersReducedMotion() || !src || !target || !document.body.animate) {
      done();
      return;
    }

    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !from.height) {
      done();
      return;
    }

    var ghost = document.createElement('img');
    ghost.src = src;
    ghost.alt = '';
    ghost.className = 'pc-fly-ghost';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    document.body.appendChild(ghost);

    var targetY = Math.max(to.top + to.height / 2, 12);
    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = targetY - (from.top + from.height / 2);
    var lift = Math.min(Math.max(Math.sqrt(dx * dx + dy * dy) * 0.32, 40), 150);
    var ctrlX = dx * 0.5;
    var fromCenterY = from.top + from.height / 2;
    var clearance = 12 + from.height * 0.25;
    var apexAbs = Math.max(clearance, Math.min(Math.min(fromCenterY, targetY) - lift, targetY - 6));
    var m = apexAbs - fromCenterY;
    var discriminant = m * (m - dy);
    var ctrlY;
    if (m < dy && discriminant > 0) {
      ctrlY = m - Math.sqrt(discriminant);
    } else {
      ctrlY = dy * 0.45;
    }

    var frames = [];
    var steps = 24;
    for (var i = 0; i <= steps; i++) {
      var u = i / steps;
      var inv = 1 - u;
      var x = 2 * inv * u * ctrlX + u * u * dx;
      var y = 2 * inv * u * ctrlY + u * u * dy;
      frames.push({
        offset: u,
        transform: 'translate(' + x + 'px, ' + y + 'px) scale(' + (1 - 0.87 * Math.pow(u, 0.85)) + ')',
        opacity: u < 0.72 ? 1 : Math.max(0.12, 1 - (u - 0.72) / 0.28),
      });
    }

    var animation = ghost.animate(frames, {
      duration: 720,
      fill: 'forwards',
      easing: 'cubic-bezier(0.38, 0.02, 0.28, 1)',
    });

    var landed = false;
    function land() {
      if (landed) return;
      landed = true;
      ghost.remove();
      done();
    }
    animation.onfinish = land;
    setTimeout(land, 1100);
  }

  function buildCartRequest(formData) {
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;
    return config;
  }

  function initCarousel(wrap) {
    if (wrap.dataset.pcInit) return;
    wrap.dataset.pcInit = '1';
    var track = wrap.querySelector('.pc-track');
    if (!track) return;
    var prev = wrap.querySelector('.pc-arrow--prev');
    var next = wrap.querySelector('.pc-arrow--next');

    function step() {
      var card = track.querySelector('.pc-card');
      return card ? card.getBoundingClientRect().width + 16 : 240;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step() * 2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step() * 2, behavior: 'smooth' });
    });

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pc-atc]');
      if (!btn || btn.disabled || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      spawnRipple(btn, e);
      btn.classList.add('is-loading');

      var sgrVariantId = btn.getAttribute('data-sgr-deposit-variant-id');
      if (sgrVariantId && !/^\d{10,}$/.test(String(sgrVariantId).trim())) sgrVariantId = null;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      var addPromise;
      if (sgrVariantId && window.NrSgrCart) {
        addPromise = window.NrSgrCart.addItems(variantId, 1, sgrVariantId, cart, btn);
      } else {
        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map(function (section) {
              return section.id;
            })
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
        }

        addPromise = fetch(
          (window.routes && window.routes.cart_add_url) || '/cart/add',
          buildCartRequest(formData)
        ).then(function (res) {
          return res.json();
        });
      }

      addPromise
        .then(function (response) {
          if (response.status) throw new Error(response.description || 'Cart error');

          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          if (btn.pcAddedTimer) clearTimeout(btn.pcAddedTimer);
          btn.pcAddedTimer = setTimeout(function () {
            btn.classList.remove('is-added');
          }, 1800);

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-carousel',
              productVariantId: variantId,
              cartData: response,
            });
          }

          flyToCart(btn, function () {
            if (cart && typeof cart.renderContents === 'function') {
              // Starea „coș gol" e o clasă pe <cart-drawer>, iar re-randarea
              // schimbă doar interiorul lui #CartDrawer — deci clasa ar rămâne
              // pusă peste conținut proaspăt: antet ascuns, produs strivit, iar
              // open() ar căuta .drawer__inner-empty și i-ar da null lui
              // trapFocus. Dawn o șterge în product-form.js:36; aici lipsea.
              if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              cart.renderContents(response);
              bumpCart();
            } else if (window.routes && window.routes.cart_url) {
              window.location.href = window.routes.cart_url;
            } else {
              bumpCart();
            }
          });
        })
        .catch(function () {
          btn.classList.remove('is-loading');
        });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.pc-carousel').forEach(initCarousel);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
